import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { queryClient } from "@/shared/query-client/query-client";
import { toApiError } from "@/shared/utils/general";
import { createFidelizationConfiguration } from "@/shared/actions/campanas/fidelizacion.actions";

export const useCreateFidelizationConfiguration = () => {
  const mutation = useMutation({
    mutationFn: createFidelizationConfiguration,
    onSuccess: () => {
      toast.success("Configuración guardada correctamente");

      queryClient.invalidateQueries({
        queryKey: ["campaign-config-summary"],
      });

      queryClient.invalidateQueries({
        queryKey: ["campaign-config-summary", "FIDELIZATION"],
      });

      queryClient.invalidateQueries({
        queryKey: ["fidelization-configuration"],
      });
    },
    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });

  return {
    saveConfiguration: mutation.mutate,
    loading: mutation.isPending,
  };
};